import template from './accounts_installations.html';

//Instantiate Page Variables
var AccountsInstallationsViewModel = function(page)
{
	var self = this;
	self.page = page;
}

//Handle interaction with page
var AccountsInstallations = function(bindings) {
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AccountsInstallationsViewModel(this);
	this.name = 'Accounts Installations';

	document.title = this.name;

	//Event (Post/After): Load once
	this.init = function() {
		var control_panel_formatter = function(value, row, index) {
			if (['Pending Uninstallation', 'Uninstalling'].includes(row.status))
				return '';

			var ret = [];

			ret.push([`
			<button class="button is-info is-rounded control-panel" title="Control Panel">
				<span class="icon">
					<i class="fas fa-2x fa-sliders-h"></i>
				</span>
			</button>`].join(''));


			return ret.join('');
		};

		let status_formatter = (value, row, index) => {
			let status_attr = {
				"Pending Activation": 'class="fa fa-power-off" style="color:grey"',
				"Pending Install": 'class="fa fa-hourglass-o" style="color:royalblue"',
				"Installing": 'class="fa fa-hourglass-half" style="color:royalblue"',
				"Installed": 'class="fa fa-check" style="color:limegreen"',
				"Installation Error": 'class="fa fa-exclamation" style="color:tomato"',
				"Pending Uninstall": 'class="fa fa-hourglass-o" style="color:tomato"',
				"Uninstalling": 'class="fa fa-hourglass-half" style="color:tomato"',
				"Uninstalled": 'class="fa fa-trash" style="color:limegreen"',
				"Uninstall Error": 'class="fa fa-exclamation" style="color:tomato"',
				"Pending Upgrade": 'class="fa fa-hourglass-o" style="color:royalblue"',
				"Upgrading": 'class="fa fa-hourglass-half" style="color:royalblue"',
				"Upgraded": 'class="fa fa-check" style="color:limegreen"',
				"Upgrade Error": 'class="fa fa-exclamation" style="color:tomato"',
				"Pending Start": 'class="fa fa-hourglass-o" style="color:royalblue"',
				"Starting": 'class="fa fa-hourglass-half" style="color:royalblue"',
				"Started": 'class="fa fa-play" style="color:limegreen"',
				"Start Error": 'class="fa fa-exclamation" style="color:tomato"',
				"Pending Stop": 'class="fa fa-hourglass-o" style="color:royalblue"',
				"Stopping": 'class="fa fa-hourglass-half" style="color:royalblue"',
				"Stopped": 'class="fa fa-stop" style="color:black"',
				"Stop Error": 'class="fa fa-exclamation" style="color:tomato"',
				"Error": 'class="fa fa-exclamation" style="color:tomato"'
			};

			if (status_attr[value]){
				return `<i ${status_attr[value]}">&nbsp</i><span>${value}</span>`;
			}

			return value;
		};

		var control_panel_events = {
			'click .product_start': function(e, value, row, index) {
				if (row.status == 'Stopped' || row.status == 'Installed')
				{
					$.postJSON('sysctl/start', {system_name: row.system_account_name, installation_uuid: row.installation_uuid}, function(response) {
						if (response.status != 'OK')
						{
							Grape.alert({title: 'Error', type: 'error', message: response.message});
						}
						self.updateData();
					});
				}
				else
				{
					Grape.alert({title: 'Notice', type: 'info', message: "Not able to start"});
				}
			},
			'click .product_stop': function(e, value, row, index) {
				if (row.status == 'Started')
				{
					$.postJSON('sysctl/stop', {system_name: row.system_account_name, installation_uuid: row.installation_uuid}, function(response) {
						if (response.status != 'OK')
						{
							Grape.alert({title: 'Error', type: 'error', message: response.message});
						}
						self.updateData();
					});
				}
				else
				{
					Grape.alert({title: 'Notice', type: 'info', message: "Not able to stop"});
				}
			},
			'click .installation_log': function(e, value, row, index) {
				let url = '/installation/download_install_log?system_name=' + row.system_account_name + '&installation_uuid=' + row.installation_uuid;
				window.open(url);
			},
			'click .product_log': function(e, value, row, index) {
				let url = '/installation/download_product_log?system_name=' + row.system_account_name + '&installation_uuid=' + row.installation_uuid;
				window.open(url);
			},
			'click .product_delete': function(e, value, row, index) {
				$.postJSON('installation/uninstall', {system_account_name: row.system_account_name, installation_uuid: row.installation_uuid}, function(response) {
					if (response.status != 'OK')
					{
						Grape.alert({title: 'Error', type: 'error', message: response.message});
					}
					self.updateData();
				});
			},
			'click .control-panel': function(e, value, row, index) {
				Grape.show_dialog('ControlPanel', row, { onClose: function(d) {
					self.updateData();
				} });
			}
		};

		//COMPONENT: Bootstrap Table
		self.tbl_table = $("#tbl_table").bootstrapTable({
			classes: 'table is-transparent is-hoverable is-fullwidth ',
			toolbarSelector: '#table-toolbar',
			columns: [
				{
					field: 'system_url',
					title: 'URL',
					sortable: true,
					width: '',
					formatter: (value, row, index) => `<a href="https://${row.fqdn}" target="_blank">${row.fqdn}</a>`
				},
				{field: 'installation_type', title: 'Installation Type', sortable: true},
				{field: 'product_name', title: 'Product', sortable: true,
					formatter: (value, row, index) => (Grape.currentSession.roles.includes('accounts.internal')) ? `<a href="#admin/products">${value}</a>` : value
				},
				{field: 'company_name', title: 'Company', sortable: true,
					formatter: (value, row, index) => (Grape.currentSession.roles.includes('accounts.internal')) ? `<a href="#admin/accounts">${value}</a>` : value
				},
				{field: 'status', title: 'Status', sortable: true, formatter: status_formatter},
				{
					field: 'action',
					title: 'Control Panel',
					width: '100em',
					formatter:control_panel_formatter,
					events : control_panel_events
				}
			],

			dataField: 'records',

			//TABLE PROPERTIES: Paging
			pagination: true,
			pageList: [20, 50, 100],
			pageSize: 20,
			sidePagination: 'server',
			onPageChange: function(number, size) {
				self.updateData();
			},

			//TABLE PROPERTIES: Sort
			sortOrder: 'asc',
			sortName: 'system_account_name',
			onSort: function(sortName, sortOrder) {
				self.updateData({sort_column: sortName, sort_order: sortOrder});
			},

			//TABLE PROPERTIES: Search
			search: true,
			searchSelector: '#custom-table-search-input',
			search_column: 'fqdn',
			searchOnEnterKey: true
		});

	};

	this.btnAddInstallation_click = function(model, e) {
		Grape.show_dialog('AddInstallation', {}, { onClose: function(d) {
			self.updateData();
		} });
	};

	//Event (Post/After): Refresh page data
	this.updateData = function(_obj) {
		let bt_options = $("#tbl_table").bootstrapTable('getOptions');
		Grape.tables.select(Object.assign(bt_options, {schema:'account', tablename: 'v_installations'}), function (response) {
			if (response.records == null)
				response.records = [];
			$("#tbl_table").bootstrapTable('load', response);
		});
	};

	//Event (Pre/Before): Remove
	this.teardown = function() {

	};

	function wait_until_is_done(callback,obj) {
		var interval = setInterval(function(){
			$.getJSON(`/installation/status/`, {account_installation_id: obj.account_installation_id}, function(res) {
				if(res =='running'){
					//do nothing
				}else{
					self.updateData();
					clearInterval(interval);
					callback;
				}
			});
		},15000);
	};

};

export default {
	route: '[/]admin/accounts_installations',
	page_class: AccountsInstallations,
	template: template
};
